import * as THREE from 'three';
// Importing necessary modules from the 'three' library and other dependencies
import EventDispatcher from './EventDispatcher';
import Global from './Global';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'; // Correct import

// Constants for asset types
const ASSET_TYPES = {
  TEXTURES: 'textures',
  CUBEMAP: 'cubemap',
  GLBS: 'glbs',
  SOUNDS: 'sounds',
};

// Constants for event types
const EVENT_TYPES = {
  LOAD_COMPLETE: 'load_complete',
  ADD_SKY: 'add_sky',
};

// AssetLoader class definition
export default class AssetLoader {
  // Constructor takes a scene as a parameter
  constructor(scene) {
    this.scene = scene;
  }

  // Initialization method for setting up loaders and loading manager
  init() {
    // Getting the event dispatcher instance
    this.events = EventDispatcher.getObj();
    this.baseURL = ''; // Set the base URL for asset loading (if applicable)

    // Setting up the LoadingManager with callbacks for completion and error handling
    this.loadingMgr = new THREE.LoadingManager(
      // On load complete callback
      () => {
        // Dispatching events indicating that loading is complete
        this.events.dispatchEvent({
          type: 'LOADER_EVENTS',
          message: { event_type: EVENT_TYPES.LOAD_COMPLETE, data: {} },
        });
        this.events.dispatchEvent({
          type: 'GAMESCENE_EVENTS',
          message: { event_type: EVENT_TYPES.ADD_SKY, data: {} },
        });
      }
      // On progress callback (not utilized in this case)
      // () => {
      //        console.log(this.loadingMgr,' loading progress')
      //
      //    },
      //    // On error callback (not utilized in this case)
      //    () => {}
    );
    this.loadingMgr.onProgress = function (url, itemsLoaded, itemsTotal) {
      // if (itemsLoaded >= 39) {
      //   this.events.dispatchEvent({type: 'LOADER_EVENTS', message: {'event_type': EVENT_TYPES.LOAD_COMPLETE, 'data': {}}})
      //   this.events.dispatchEvent({type: 'GAMESCENE_EVENTS', message: {'event_type': EVENT_TYPES.ADD_SKY, 'data': {}}})
      // }
      const progress = itemsLoaded / itemsTotal;
      document.querySelector(
        '.loading_sec .progress'
      ).style.transform = `translateX(${-100 + progress * 100}%)`;
      // Update your progress bar or UI element here
    };
    // Setting up various loaders with the loading manager
    this.textureLoader = new THREE.TextureLoader(this.loadingMgr); // Loader for 2D textures
    this.textureLoader.setPath(this.baseURL);

    this.audioLoader = new THREE.AudioLoader(this.loadingMgr); // Loader for audio files
    this.audioLoader.setPath(this.baseURL);

    this.cubeTextureLoader = new THREE.CubeTextureLoader(this.loadingMgr); // Loader for cube textures (cubemaps)
    this.cubeTextureLoader.setPath(this.baseURL);

    // console.log(THREE.DRACOLoader, 'DRACOLoader')
    // const dracoLoader = new THREE.DRACOLoader()
    // dracoLoader.setDecoderPath('/draco/')

    this.gltfLoader = new GLTFLoader(this.loadingMgr); // Loader for GLTF models (3D models)
    // this.gltfLoader.setDRACOLoader(dracoLoader)
  }

  prepare() {
    // preloadImage('/ui/SplashBG.png', 'SplashBG', 0).then(()=>{

    //     document.querySelector("#splash_scr").style.backgroundImage= `url(${getPreloadImage("SplashBG")})`;
    //     return preloadImage('/ui/home_cars.png', 'home_cars', 1)
    // }).then(()=>{
    //     return preloadImage('/ui/homeBG.png', 'homeBG', 1)
    // }).then(()=>{
    //     return preloadImage('/ui/selectionBG.png', 'selectionBG', 1)
    // }).then(()=>{

    // })
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_splash',
        data: {},
      },
    });

    this.load();
  }

  // Load method to load assets based on the global asset configuration
  load() {
    // Extracting the assets configuration from the global variable
    const assetsToLoad = Global.assets;

    // Iterating through different types of assets (textures, cubemaps, glbs)
    Object.keys(assetsToLoad).forEach((typeKey) => {
      const itemKeys = Object.keys(assetsToLoad[typeKey]);

      // Iterating through individual items within each asset type
      itemKeys.forEach((itemKey) => {
        // Loading textures and storing them in the class instance
        if (typeKey === ASSET_TYPES.TEXTURES) {
          this[assetsToLoad[typeKey][itemKey].key] = this.textureLoader.load(
            assetsToLoad[typeKey][itemKey].path[0]
          );
          Global.assets[typeKey][itemKey].asset =
            this[assetsToLoad[typeKey][itemKey].key];
        }

        // Loading cubemaps and storing them in the class instance
        if (typeKey === ASSET_TYPES.CUBEMAP) {
          this[assetsToLoad[typeKey][itemKey].key] =
            this.cubeTextureLoader.load(assetsToLoad[typeKey][itemKey].path);
          Global.assets[typeKey][itemKey].asset =
            this[assetsToLoad[typeKey][itemKey].key];
        }

        // Loading glbs and storing them in the class instance
        if (typeKey === ASSET_TYPES.GLBS) {
          this[assetsToLoad[typeKey][itemKey].key] = this.gltfLoader.load(
            assetsToLoad[typeKey][itemKey].path[0],
            (gltf) => {
              Global.assets[typeKey][itemKey].asset = gltf;
            }
          );
        }
        if (typeKey === ASSET_TYPES.SOUNDS) {
          this[assetsToLoad[typeKey][itemKey].key] = this.audioLoader.load(
            assetsToLoad[typeKey][itemKey].path[0],
            (sound) => {
              Global.assets[typeKey][itemKey].asset = sound;
            }
          );
        }
      });
    });
  }
}
